import { useMutation } from '@apollo/client'
import { MaterializedProcessesDataTableDocument } from 'generated/resources/datatable.graphql'
import {
  MarkMaterializedProcessAsCompletedDocument,
  MaterializedProcessDocument,
} from 'generated/resources/graphql'

export const useMarkAsCompletedMaterializedProcess = () => {
  const [executeMutation] = useMutation(MarkMaterializedProcessAsCompletedDocument)
  const markAsCompletedMaterializedProcess = async (id: number) => {
    const { data, errors } = await executeMutation({
      variables: {
        id,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: MaterializedProcessesDataTableDocument,
          variables: {
            ids: [id],
          },
        },
        {
          query: MaterializedProcessDocument,
          variables: {
            id: id,
          },
        },
      ],
    })

    if (
      errors?.length ||
      data?.processesMutations?.markAsCompletedProcessesMaterializedProcess?.errors.length
    ) {
      throw (
        'Could not mark process as completed: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.markAsCompletedProcessesMaterializedProcess?.errors || []),
        ])
      )
    }
  }

  return {
    markAsCompletedMaterializedProcess,
  }
}
